/* tslint:disable */
/* eslint-disable */
/**
 * Sports App Training Plans
 * API for the Sports App Training Plans
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AssignTrainee
 */
export interface AssignTrainee {
    /**
     * 
     * @type {string}
     * @memberof AssignTrainee
     */
    trainerId: string;
    /**
     * 
     * @type {string}
     * @memberof AssignTrainee
     */
    traineeId: string;
}

/**
 * Check if a given object implements the AssignTrainee interface.
 */
export function instanceOfAssignTrainee(value: object): value is AssignTrainee {
    if (!('trainerId' in value) || value['trainerId'] === undefined) return false;
    if (!('traineeId' in value) || value['traineeId'] === undefined) return false;
    return true;
}

export function AssignTraineeFromJSON(json: any): AssignTrainee {
    return AssignTraineeFromJSONTyped(json, false);
}

export function AssignTraineeFromJSONTyped(json: any, ignoreDiscriminator: boolean): AssignTrainee {
    if (json == null) {
        return json;
    }
    return {
        
        'trainerId': json['trainerId'],
        'traineeId': json['traineeId'],
    };
}

export function AssignTraineeToJSON(json: any): AssignTrainee {
    return AssignTraineeToJSONTyped(json, false);
}

export function AssignTraineeToJSONTyped(value?: AssignTrainee | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'trainerId': value['trainerId'],
        'traineeId': value['traineeId'],
    };
}

